import { Badge } from "@/components/ui/badge";
import { Shield, Award } from "lucide-react";

const Certifications = () => {
  const certifications = [
    { name: "ISO 27001", icon: Shield },
    { name: "AWS Partner", icon: Award },
    { name: "SAP Partner", icon: Award },
  ];

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-gradient-to-br from-primary/5 via-secondary/5 to-background border-y border-secondary/20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <Badge className="mb-4 bg-primary/10 text-primary border-primary/30 text-sm px-4 py-1.5 shadow-sm">
            Certified & Recognized
          </Badge>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4 bg-duo-gradient bg-clip-text text-transparent pb-2">
            Enterprise-grade partnerships and certifications
          </h2>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 sm:gap-8 md:gap-12 max-w-4xl mx-auto">
          {certifications.map((cert, index) => {
            const IconComponent = cert.icon;
            return (
              <div
                key={index}
                className={`group flex items-center gap-3 px-6 py-4 rounded-xl bg-gradient-to-br from-white/80 to-white/60 backdrop-blur-sm border-2 ${index % 2 === 0 ? "border-primary/20 hover:border-primary" : "border-secondary/20 hover:border-secondary"} hover:shadow-elegant transition-all duration-300 hover:-translate-y-1`}
              >
                <div
                  className={`${index % 2 === 0 ? "bg-primary/10" : "bg-secondary/10"} p-2.5 rounded-lg ${index % 2 === 0 ? "group-hover:bg-primary/20" : "group-hover:bg-secondary/20"} transition-colors`}
                >
                  <IconComponent
                    className={`h-6 w-6 ${index % 2 === 0 ? "text-primary shadow-glow" : "text-secondary"}`}
                  />
                </div>
                <span className="text-base sm:text-lg font-semibold text-foreground">
                  {cert.name}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Certifications;
